import { debouncer } from "../utility/utils";

export const InitMediaBlocks = () => {
  const scrollableMedia = document.querySelectorAll('.media_block.has_min_width');

  if(scrollableMedia){
    scrollableMedia.forEach(el => {
      let isScrollable = false;
      let lastXPos;
      
      checkScrollableMediaCursor(el);
      
      el.addEventListener('mousedown', (e) => {
        isScrollable = true;
        lastXPos = e.clientX;
        el.classList.add('grabbing');
      });
      el.addEventListener('mousemove', (e) => {
        if(isScrollable){
          const amountMoved = e.clientX - lastXPos;
          el.scrollLeft -= amountMoved;
          lastXPos = e.clientX;
        }
      });
      el.addEventListener('mouseup', () => {
        isScrollable = false;
        el.classList.remove('grabbing');
      });
      el.addEventListener('mouseleave', () => {
        isScrollable = false;
        el.classList.remove('grabbing');
      });
    });

    window.addEventListener('resize', debouncer(() => {
      checkScrollableMediaCursor();
    }, 20));
  }
}

const checkScrollableMediaCursor = (img = null) => {
  if(!img){
    images = document.querySelectorAll('.media_block.has_min_width');
    if(images){
      images.forEach(img => {
        checkScrollableMediaCursor(img);
      });
    }
  }
  else {
    const windowWidth = window.innerWidth;
    const imageWidth = img.getAttribute('data-min-width');

    if(imageWidth > windowWidth){
      img.classList.add('isScrollable');
    }
    else if(img.classList.contains('isScrollable')){
      img.classList.remove('isScrollable');
    }
  }
}